import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { Mod0104PageRoutingModule } from './mod0104-routing.module';

import { Mod0104Page } from './mod0104.page';
import { NavbarComponent } from '../../navbar/navbar.component';

import { PaginationComponentComponent } from 'src/app/components/pagination-component/pagination-component.component';
import { SearchboxComponent } from 'src/app/components/searchbox/searchbox.component';
import { LoaderComponent } from 'src/app/components/loader/loader.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, Mod0104PageRoutingModule],
  declarations: [
    Mod0104Page,
    NavbarComponent,
    PaginationComponentComponent,
    SearchboxComponent,
    LoaderComponent,
  ],
})
export class Mod0104PageModule {}
